import * as React from "react";
import styled from "styled-components";

import { DetailContainer } from "../common/detail-container";

import { RejectRelease } from './reject-release';
import { EditReleaseCtrl } from './edit-release';
import { AcceptRelease } from './accept-release';
import { DetailActionProps } from './detail-actions-props';
import { TakeDownRelease } from './takedown-release';
import { TransferRelease } from './transfer-release';
import { TrashRelease } from './trash-release';

export const ReleaseDetailActions: React.FC<DetailActionProps> = (props) => {
  const isPublished = props?.data[0]?.release?.isPublished || false;
  return (
    <DetailContainer>
      <ActionContainer>
        <TrashRelease {...props} />
        <TransferRelease {...props} />
        { props.status === 'pending' && <RejectRelease {...props} /> }
        { isPublished && props.status !== 'taken-down' && <TakeDownRelease {...props} /> }
        <EditReleaseCtrl {...props} />
        { props.status === 'pending' && <AcceptRelease {...props} /> }
      </ActionContainer>
    </DetailContainer>
  );
};

const ActionContainer = styled.div`
  float: right;
  width: 100%;
  height: 100%;
  // max-width: 600px;
  display: flex;
  box-sizing: border-box;
  justify-content: flex-end;
  & > button {
    margin-left: 0.25rem;
  }
`;
